import React, { PropTypes, useEffect } from 'react';
import { Grid, Select, MenuItem, Checkbox, Typography, FormControl, Button } from '@material-ui/core';
import NewPatientPhoto from './NewPatientPhoto';
import style from './NewPatientPhotos.module.css';
import { useLang } from '../../../util/lang';
import Moment from 'moment/moment';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import FacialScanUploader from './FacialScanUploader';
import { useSelector } from 'react-redux';

/**
 * Renders the New Patient photograph upload sections.
 */
const Photos = (props) => {
    const get = useLang('NewPatient');
    const displayFirstFitFlag = useSelector((state) => state.globalReducer.displayFirstFitFlag);

    return (
        <>
            {['INTERNATIONAL'].includes(process.env.REACT_APP_ENV) &&
                ['DR'].includes(JSON.parse(localStorage.getItem('role'))) && (
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Select
                                displayEmpty
                                variant="outlined"
                                value={props.chosenDraftFile ?? 0}
                                onChange={(event) => props.handleChoose(event.target.value)}
                                style={{ width: '100%' }}
                            >
                                <MenuItem value={0} key={0}>
                                    {get('photographs.chooseFromYourGallery')}
                                </MenuItem>
                                {props.draftFileList &&
                                    props.draftFileList.map((v) => (
                                        <MenuItem value={v.doctor_app_file_id} key={v.doctor_app_file_id}>
                                            {v.first_name}, {v.last_name}, created at{' '}
                                            {Moment(v.created_date).format('DD-MMM-YYYY')}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </Grid>
                    </Grid>
                )}
            <Grid container spacing={3}>
                <h2
                    className={style.subHeading}
                >{`${get(':uploadType.mandatory')} ${get('photographs.photographs')}`}</h2>
                <Grid item xs={12} sm={4}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            imageId="jaw_side_with_smile"
                            imageUploaded={props.imageUploaded('jaw_side_with_smile')}
                            imageData={props.imageData('jaw_side_with_smile')}
                            label={get('photographs.uploadThisPhotoLater')}
                            descLabel={
                                get('photographs.desc_jaw_side_with_smile') != 'N/A'
                                    ? get('photographs.desc_jaw_side_with_smile')
                                    : ''
                            }
                            imageName="pbg11.png"
                            flip="true"
                            mandatoryImage={props.parent === 'refinement' ? false : true}
                            fliplabel1="Q1"
                            fliplabel2="Q2"
                            uploadLater={props.parent === 'refinement' ? true : false}
                            no_warning={props.parent === 'refinement' ? true : false}
                            will_not_upload={props.parent === 'refinement' ? true : false}
                            will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                            handleRoatate={(degree) => {
                                props.handleRoatate('jaw_side_with_smile', degree);
                            }}
                            handleInvert={(invert) => {
                                props.invert('jaw_side_with_smile', invert);
                            }}
                            handleChange={(file) => {
                                props.handleChange('jaw_side_with_smile', file);
                            }}
                        />
                    </li>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            fliplabel1={get('@NewPatient.impressions.label.FrontalExtraoralFacial')}
                            fliplabel2=""
                            imageId="face_front_with_smile"
                            imageUploaded={props.imageUploaded('face_front_with_smile')}
                            imageData={props.imageData('face_front_with_smile')}
                            label={get('photographs.uploadThisPhotoLater')}
                            descLabel={
                                get('photographs.face_front_with_smile') != 'N/A'
                                    ? get('photographs.face_front_with_smile')
                                    : ''
                            }
                            imageName="front_smile.png"
                            mandatoryImage={props.parent === 'refinement' ? false : true}
                            uploadLater={props.parent === 'refinement' ? true : false}
                            no_warning={props.parent === 'refinement' ? true : false}
                            will_not_upload={props.parent === 'refinement' ? true : false}
                            will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                            handleRoatate={(degree) => {
                                props.handleRoatate('face_front_with_smile', degree);
                            }}
                            handleChange={(file) => {
                                props.handleChange('face_front_with_smile', file);
                            }}
                        />
                    </li>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            fliplabel1={get('@NewPatient.impressions.label.IntraoralRight')}
                            imageId="teeth_side_without_smile"
                            imageUploaded={props.imageUploaded('teeth_side_without_smile')}
                            imageData={props.imageData('teeth_side_without_smile')}
                            label={get('photographs.uploadThisPhotoLater')}
                            descLabel={
                                get('photographs.teeth_side_without_smile') != 'N/A'
                                    ? get('photographs.teeth_side_without_smile')
                                    : ''
                            }
                            imageName="pbg13.png"
                            flip="true"
                            mandatoryImage={props.parent === 'refinement' ? false : true}
                            uploadLater={props.parent === 'refinement' ? true : false}
                            no_warning={props.parent === 'refinement' ? true : false}
                            will_not_upload={props.parent === 'refinement' ? true : false}
                            will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                            handleRoatate={(degree) => {
                                props.handleRoatate('teeth_side_without_smile', degree);
                            }}
                            handleInvert={(invert) => {
                                props.invert('teeth_side_without_smile', invert);
                            }}
                            handleChange={(file) => {
                                props.handleChange('teeth_side_without_smile', file);
                            }}
                        />
                    </li>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            imageId="jaw_front_with_smile"
                            imageUploaded={props.imageUploaded('jaw_front_with_smile')}
                            imageData={props.imageData('jaw_front_with_smile')}
                            label={get('photographs.uploadThisPhotoLater')}
                            descLabel={
                                get('photographs.jaw_front_with_smile') != 'N/A'
                                    ? get('photographs.jaw_front_with_smile')
                                    : ''
                            }
                            imageName="pbg12.png"
                            handleRoatate={(degree) => {
                                props.handleRoatate('jaw_front_with_smile', degree);
                            }}
                            flip="true"
                            fliplabel1="Q4"
                            fliplabel2="Q3"
                            mandatoryImage={props.parent === 'refinement' ? false : true}
                            uploadLater={props.parent === 'refinement' ? true : false}
                            no_warning={props.parent === 'refinement' ? true : false}
                            will_not_upload={props.parent === 'refinement' ? true : false}
                            will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                            handleInvert={(invert) => {
                                props.invert('jaw_front_with_smile', invert);
                            }}
                            handleChange={(file) => {
                                props.handleChange('jaw_front_with_smile', file);
                            }}
                        />
                    </li>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            fliplabel1={get('@NewPatient.impressions.label.IntraoralFrontal')}
                            imageId="teeth_side_with_smile"
                            imageUploaded={props.imageUploaded('teeth_side_with_smile')}
                            imageData={props.imageData('teeth_side_with_smile')}
                            label={get('photographs.uploadThisPhotoLater')}
                            descLabel={
                                get('photographs.teeth_side_with_smile') != 'N/A'
                                    ? get('photographs.teeth_side_with_smile')
                                    : ''
                            }
                            imageName="pbg10.png"
                            mandatoryImage={props.parent === 'refinement' ? false : true}
                            uploadLater={props.parent === 'refinement' ? true : false}
                            no_warning={props.parent === 'refinement' ? true : false}
                            will_not_upload={props.parent === 'refinement' ? true : false}
                            will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                            handleRoatate={(degree) => {
                                props.handleRoatate('teeth_side_with_smile', degree);
                            }}
                            handleChange={(file) => {
                                props.handleChange('teeth_side_with_smile', file);
                            }}
                        />
                    </li>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            // fliplabel1={get("NewPatient.impressions.label.IntraoralLeft")}
                            fliplabel1={get('@NewPatient.impressions.label.IntraoralLeft')}
                            imageId="jaw_side_without_smile"
                            imageUploaded={props.imageUploaded('jaw_side_without_smile')}
                            imageData={props.imageData('jaw_side_without_smile')}
                            label={get('photographs.uploadThisPhotoLater')}
                            descLabel={
                                get('photographs.jaw_side_without_smile') != 'N/A'
                                    ? get('photographs.jaw_side_without_smile')
                                    : ''
                            }
                            imageName="pbg14.png"
                            flip="true"
                            mandatoryImage={props.parent === 'refinement' ? false : true}
                            uploadLater={props.parent === 'refinement' ? true : false}
                            no_warning={props.parent === 'refinement' ? true : false}
                            will_not_upload={props.parent === 'refinement' ? true : false}
                            will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                            handleRoatate={(degree) => {
                                props.handleRoatate('jaw_side_without_smile', degree);
                            }}
                            handleInvert={(invert) => {
                                props.invert('jaw_side_without_smile', invert);
                            }}
                            handleChange={(file) => {
                                props.handleChange('jaw_side_without_smile', file);
                            }}
                        />
                    </li>
                </Grid>
                {displayFirstFitFlag && (
                    <Grid item xs={12} sm={4}>
                        <li>
                            <NewPatientPhoto
                                mode={props.mode}
                                fliplabel1="Big smile, full face, with full retractors"
                                fliplabel2=""
                                imageId="big_smile_full_face_with_full_retractors"
                                imageUploaded={props.imageUploaded('big_smile_full_face_with_full_retractors')}
                                imageData={props.imageData('big_smile_full_face_with_full_retractors')}
                                label={get('photographs.uploadThisPhotoLater')}
                                imageName="Extraoral with retractors.png"
                                mandatoryImage={props.parent === 'refinement' ? false : true}
                                uploadLater={props.parent === 'refinement' ? true : false}
                                no_warning={props.parent === 'refinement' ? true : false}
                                will_not_upload={props.parent === 'refinement' ? true : false}
                                will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                                handleRoatate={(degree) => {
                                    props.handleRoatate('big_smile_full_face_with_full_retractors', degree);
                                }}
                                handleChange={(file) => {
                                    props.handleChange('big_smile_full_face_with_full_retractors', file);
                                }}
                            />
                        </li>
                    </Grid>
                )}
            </Grid>

            <Grid container spacing={3}>
                <h2 className={style.subHeading}>{get(':uploadType.stronglyRecommended')}</h2>
                <Grid item xs={12} sm={4}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            imageId="face_side_with_smile"
                            imageData={props.imageData('face_side_with_smile')}
                            imageUploaded={props.imageUploaded('face_side_with_smile')}
                            label={get('photographs.uploadThisPhotoLater')}
                            descLabel={
                                get('photographs.face_side_with_smile') != 'N/A'
                                    ? get('photographs.face_side_with_smile')
                                    : ''
                            }
                            imageName="side_smile.png"
                            uploadLater={props.uploadLater}
                            no_warning={props.parent === 'refinement' ? true : false}
                            will_not_upload={props.parent === 'refinement' ? true : false}
                            will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                            handleRoatate={(degree) => {
                                props.handleRoatate('face_side_with_smile', degree);
                            }}
                            handleChange={(file) => {
                                props.handleChange('face_side_with_smile', file);
                            }}
                        />
                    </li>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            imageId="teeth_front_with_smile"
                            imageUploaded={props.imageUploaded('teeth_front_with_smile')}
                            imageData={props.imageData('teeth_front_with_smile')}
                            label={get('photographs.uploadThisPhotoLater')}
                            descLabel={
                                get('photographs.teeth_front_with_smile') != 'N/A'
                                    ? get('photographs.teeth_front_with_smile')
                                    : ''
                            }
                            imageName="front_normal.png"
                            uploadLater={props.uploadLater}
                            no_warning={props.parent === 'refinement' ? true : false}
                            will_not_upload={props.parent === 'refinement' ? true : false}
                            will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                            handleRoatate={(degree) => {
                                props.handleRoatate('teeth_front_with_smile', degree);
                            }}
                            handleChange={(file) => {
                                props.handleChange('teeth_front_with_smile', file);
                            }}
                        />
                    </li>
                </Grid>

                <Grid item xs={12} sm={4}>
                    <li>
                        <NewPatientPhoto
                            mode={props.mode}
                            imageId="face_side_without_smile"
                            imageUploaded={props.imageUploaded('face_side_without_smile')}
                            imageData={props.imageData('face_side_without_smile')}
                            label={get('photographs.uploadThisPhotoLater')}
                            descLabel={
                                get('photographs.face_side_without_smile') != 'N/A'
                                    ? get('photographs.face_side_without_smile')
                                    : ''
                            }
                            imageName="side_without_smile.png"
                            uploadLater={props.uploadLater}
                            no_warning={props.parent === 'refinement' ? true : false}
                            will_not_upload={props.parent === 'refinement' ? true : false}
                            will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                            handleRoatate={(degree) => {
                                props.handleRoatate('face_side_without_smile', degree);
                            }}
                            handleChange={(file) => {
                                props.handleChange('face_side_without_smile', file);
                            }}
                        />
                    </li>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                    <h2 className={style.subHeading}>{get(':uploadType.free_angle_optional')}</h2>
                    <Grid item xs={12} sm={6}>
                        <li>
                            <NewPatientPhoto
                                mode={props.mode}
                                imageId="free_angle_one"
                                imageUploaded={props.imageUploaded('free_angle_one')}
                                imageData={props.imageData('free_angle_one')}
                                label={get('photographs.uploadThisPhotoLater')}
                                descLabel={
                                    get('photographs.free_angle_one') != 'N/A' ? get('photographs.free_angle_one') : ''
                                }
                                imageName="side_without_smile.png"
                                uploadLater={props.uploadLater}
                                no_warning={props.parent === 'refinement' ? true : false}
                                will_not_upload={props.parent === 'refinement' ? true : false}
                                will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                                handleRoatate={(degree) => {
                                    props.handleRoatate('free_angle_one', degree);
                                }}
                                handleChange={(file) => {
                                    props.handleChange('free_angle_one', file);
                                }}
                            />
                        </li>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <li>
                            <NewPatientPhoto
                                mode={props.mode}
                                imageId="free_angle_two"
                                imageUploaded={props.imageUploaded('free_angle_two')}
                                imageData={props.imageData('free_angle_two')}
                                label={get('photographs.uploadThisPhotoLater')}
                                descLabel={
                                    get('photographs.free_angle_two') != 'N/A' ? get('photographs.free_angle_two') : ''
                                }
                                imageName="side_without_smile.png"
                                uploadLater={props.uploadLater}
                                no_warning={props.parent === 'refinement' ? true : false}
                                will_not_upload={props.parent === 'refinement' ? true : false}
                                will_not_upload_label={get(':uploadType.willNotUploadPhoto')}
                                handleRoatate={(degree) => {
                                    props.handleRoatate('free_angle_two', degree);
                                }}
                                handleChange={(file) => {
                                    props.handleChange('free_angle_two', file);
                                }}
                            />
                        </li>
                    </Grid>
                    {!displayFirstFitFlag &&(props.enableRaySelectChoose3dFile === false && props.isRayCase === 1 ? (
                        <>
                            <h2 className={style.subHeading}>{get('@NewPatient.3dFile.3dFacialDataGallery')}</h2>
                            <Grid item xs={12} sm={6}>
                                <li>
                                    <div
                                        style={{
                                            marginLeft: '15px',
                                            marginTop: '-10px',
                                        }}
                                    >
                                        {get('@NewPatient.3dFile.3dfacialDataisUploaded')}
                                    </div>
                                </li>
                            </Grid>
                        </>
                    ) : (
                        props.rayFiles &&
                        props.rayFiles.length > 0 && (
                            <>
                                <h2 className={style.subHeading}>{get('@NewPatient.3dFile.3dFacialDataGallery')}</h2>
                                <Grid item xs={12} sm={6}>
                                    <div
                                        style={{
                                            marginLeft: '15px',
                                            marginRight: '15px',
                                            marginTop: '-10px',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <FormControlLabel
                                            value={props.enableRaySelectChoose3dFile}
                                            control={<Checkbox checked={props.enableRaySelectChoose3dFile} />}
                                            label={get('@NewPatient.3dFile.choose3dVendor')}
                                            onChange={(e) => props.handleEnableChoose3dFileChange(e.target.checked)}
                                        />
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            onClick={() =>
                                                props.handleUseFiles(
                                                    props.rayFiles.find((f) => f.id == props.caseRfsId)
                                                )
                                            }
                                            disabled={!props.enableRaySelectChoose3dFile || !props.caseRfsId}
                                        >
                                            {get('@NewPatient.3dFile.useFiles')}
                                        </Button>
                                    </div>
                                    <div className={style.card}>
                                        <FormControl component="fieldset">
                                            <RadioGroup defaultValue={props.caseRfsId && props.caseRfsId.toString()}>
                                                {props.rayFiles &&
                                                    props.rayFiles.length > 0 &&
                                                    props.rayFiles.map((file) => (
                                                        <FormControlLabel
                                                            key={file.id}
                                                            value={file.id.toString()}
                                                            control={<Radio />}
                                                            label={`${file.first_name} ${file.last_name} ${Moment(file.created_date).format('YYYY-MM-DD HH:mm')}`}
                                                            onChange={(e) => props.handleChoose3dFile(e.target.value)}
                                                            disabled={!props.enableRaySelectChoose3dFile}
                                                        />
                                                    ))}
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                </Grid>
                            </>
                        )
                    ))}
            </Grid>
            {displayFirstFitFlag &&
            <Grid container spacing={3}>
                <Grid item xs={12} className={style.facialScanSection}>
                            <h2 className={style.facialScanHeading}>{get(':uploadType.DFacialScan')} <span>({get(':uploadType.Optional')})</span></h2>
                            <p className={style.facialScanDescription}>
                                {get(':uploadType.ray_face_scan_info')}
                            </p>
                            <Grid container spacing={3}>
                                {props.rayFiles && props.rayFiles.length > 0 && (
                                <Grid item xs={12} sm={6}>
                                    <div className={style.rayFacePanel}>
                                        <p>{get(':uploadType.ray_face_scan_import_info')}</p>
                                        {/* <Button
                                            variant="contained"
                                            color="secondary"
                                            className={style.rayFaceButton}
                                            onClick={() => props.handleEnableChoose3dFileChange(true)}
                                        >
                                            {get(':uploadType.ray_face_scan_connect_rayFace')}
                                        </Button> */}
                                        {props.enableRaySelectChoose3dFile === false && props.isRayCase === 1 ? (
                                            <p className={style.rayFaceStatus}>
                                                {get('@NewPatient.3dFile.3dfacialDataisUploaded')}
                                            </p>
                                        ) : (
                                            props.rayFiles && props.rayFiles.length > 0 && <>
                                                <FormControlLabel
                                                    className={style.rayFaceChoice}
                                                    value={props.enableRaySelectChoose3dFile}
                                                    control={<Checkbox checked={props.enableRaySelectChoose3dFile} />}
                                                    label={get('@NewPatient.3dFile.choose3dVendor')}
                                                    onChange={(e) => props.handleEnableChoose3dFileChange(e.target.checked)}
                                                />
                                                {props.enableRaySelectChoose3dFile && (
                                                    <>
                                                        <Button
                                                            variant="contained"
                                                            color="secondary"
                                                            className={style.useRayFaceFilesButton}
                                                            onClick={() =>
                                                                props.handleUseFiles(
                                                                (props.rayFiles || []).find((f) => f.id == props.caseRfsId)
                                                                )
                                                            }
                                                            disabled={!props.caseRfsId}
                                                        >
                                                            {get('@NewPatient.3dFile.useFiles')}
                                                        </Button>
                                                        <div className={style.rayFaceFileList}>
                                                            <FormControl component="fieldset">
                                                                <RadioGroup value={props.caseRfsId ? props.caseRfsId.toString() : ''}>
                                                                    {(props.rayFiles || []).map((file) => (
                                                                        <FormControlLabel
                                                                            key={file.id}
                                                                            value={file.id.toString()}
                                                                            control={<Radio />}
                                                                            label={`${file.first_name} ${file.last_name} ${Moment(file.created_date).format('YYYY-MM-DD HH:mm')}`}
                                                                            onChange={(e) => props.handleChoose3dFile(e.target.value)}
                                                                        />
                                                                    ))}
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </div>
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </Grid>
                                )}
                                <Grid item xs={12} sm={6}>
                                    <FacialScanUploader
                                        facialScan={props.facialScan}
                                        handleChange={props.handleFacialScan}
                                        mode={props.mode}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
            </Grid> }
        </>
    );
};
export default Photos;
